import {
  Button,
  Dialog,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  RadioGroup,
  FormControlLabel,
  Radio,
  Box,
  Typography,
  makeStyles
} from "@material-ui/core";
import { useEffect, useState } from "react";
import en from "../../../lang/en-us";
import { CustomRadio } from "../../../lib/CustomRadio";
import { saveNominee, sendPhoneOTP } from "../../../store/actions/nct";
import TextInput from "../../../lib/TextField";
import AddNominee from "./addNominee";
import * as yup from "yup";
import { SubmitButtonWithLoader } from "../../../lib/Button";
import { NoteModals } from "../../../lib/NoteModals";
import { connect, useDispatch, useSelector } from "react-redux";
import {
  getDate,
  getDateString,
  UPDATE_NOMINEE,
  OTP_ACTIONS,
  panRegex,
  _minDateForCalender,
} from "../../../utils/constants";
import { getNameIndex } from "../CorrectionFolios/correction-folios-selection";
import { CheckBoxField } from "../../../lib/CheckBoxField";
import { UPDATE_NOMINEE_ARRAY } from "../../../store/types/nominees";
// import { defaultOptions, DigioParamsType, parseNomineeDetailsForEsign, submitDigioDocument, VerifyThrough } from './utils';
import { FormattedNomineeType, NomineeInfoRowData } from "./types";
import { RootStateType } from "../../../store/reducers";
import { useHistory, useLocation } from "react-router-dom";
import { NomineeReducerState } from "../../../store/reducers/nominees";
import Image from "../../Image";
import { differenceInYears } from "date-fns";
import { emailRegex, nomineePanRegex, drivingLicenseRegex, mobileRegex, passportNumberRegex ,isOnlyNumber} from "../transactions/newInvestor";
import { validateNomineeDetails,getRelationShipList,getCountriesList } from "../../../store/actions";
const {
  dashboard,
  signUp: { form },
  dbCommercial,
  common,
} = en;
const useStyles = makeStyles(() => ({
  radio: {
    color: '#007ac8',
  },
}));

export interface InitialState {
  relation: string;
  name: string;
  dob: Date | string;
  share: number | null;
  mobileNumber: string;
  email: string;
  idType: string;
  idNumber: string;
  address1: string;
  address2: string;
  address3?: string;
  pincode: number | string;
  city: string;
  state: string;
  country: string;
  guardianName: string;
  inCapacitation?: boolean;
  inCapacitationAmountorPercentageCheck?: string;
  inCapacitationAmount: number | string;
  addressCheck?: boolean;
  isEditable?: boolean;
  isNewlyAdded?: boolean;
  showDetails?: boolean;
  editShare?: boolean;
  id?: string;
  isEdited?: boolean;
}
export interface NOMINEEINFO extends InitialState {
  initialState?: InitialState;
}
export interface RELATIONS {
  label: string;
  value: string;
}

export const initialValues: NOMINEEINFO = {
  relation: "",
  name: "",
  dob: "",
  share: null,
  mobileNumber: "",
  email: "",
  idNumber: "",
  idType: "",
  address1: "",
  address2: "",
  address3: "",
  pincode: "",
  city: "",
  state: "",
  country: "",
  guardianName: "",
  inCapacitation: false,
  inCapacitationAmountorPercentageCheck: "Percentage",
  inCapacitationAmount: ""
};

export const validationSchemaNominee = yup.object({
  relation: yup.string().required("Relation is required"),
  name: yup.string()
    .required('Name is required')
    .matches(
      /^[A-Za-z\s]+$/,
      'Full Name should not contain numbers or special characters',
    )
    .min(3, 'Name must be at least 3 characters'),

  mobileNumber: yup
    .string()
    .required("Mobile Number is required")
    .matches(mobileRegex, "Enter a valid Mobile Number"),
  email: yup
    .string()
    .required("Email id is required")
    .matches(emailRegex, "Enter valid Email id"),
  idType: yup.string().required("ID Type is mandatory"),
  idNumber: yup.string()
    .required("ID Number is mandatory")
    .when("idType", {
      is: "Aadhar",
      then: (schema: any) =>
        schema
          .matches(/^\d{4}$/, "Please enter last four digits of Aadhaar Number")
          .test(
            "is-valid-aadhaar",
            "Enter a valid Aadhaar number",
            (value: any) => value !== "0000" // Reject 0000 as invalid
          )
          .required("Aadhaar Number is mandatory"),
    })
    .when("idType", {
      is: "PAN",
      then: (schema: any) =>
        schema
          .matches(nomineePanRegex, "Enter valid PAN")
    })
    .when("idType", {
      is: "Driving License",
      then: (schema: any) =>
        schema
          .matches(drivingLicenseRegex, "Enter valid driving licence")
    })
    .when("idType", {
      is: "Passport",
      then: (schema: any) =>
        schema
          .matches(passportNumberRegex, "Enter valid Passport Number")
    }),
    address1: yup.string().required('Address is required').test(
      'max-length',
      'Address should not exceed 40 characters (including spaces and special characters)',
      value => !!value && value.length <= 40
    ),
    address2: yup.string().notRequired().test(
      'max-length',
      'Address should not exceed 40 characters (including spaces and special characters)',
      value => !value || value.length <= 40
    ),
    address3: yup.string().notRequired().test(
      'max-length',
      'Address should not exceed 30 characters (including spaces and special characters)',
      value => !value || value.length <= 30
    ),
  city: yup
    .string()
    .required("City is required")
    .max(50, common.cityMaxLength),
  state: yup
    .string()
    .required("State is required")
    .max(50, common.stateMaxLength),
    pincode:   yup.string()
    .required("Pincode is required")
    .matches(/^[1-8][0-9]{5}$/, "Enter a valid 6-digit Indian PIN code"),
  country: yup
    .string()
    .required("Country is required"),
  inCapacitationAmount: yup.number().when('inCapacitation', {
    is: true,
    then: yup.number()
      .when('inCapacitationAmountorPercentageCheck', {
        is: 'Percentage',
        then: yup.number()
          .min(1, "Percentage must be at least 1%")
          .max(100, "Percentage should not exceed 100%")
          .required("Percentage is required"),
        otherwise: yup.number()
          .min(1, "Amount must be at least 1₹")
          .max(999999999, "Amount should not exceed 999999999")
          .required("Amount is required"),
      }),
  }),
});

export default function UpdateNomineeEdit() {
  const classes = useStyles();

  const history = useHistory();
  const location = useLocation<{
    selectedRows: NomineeInfoRowData[];
    nomineeIndex: number;
  }>();
  const { pan } = useSelector(({ authReducer }: RootStateType) => ({
    ...authReducer,
  }));
  const { investorData, token, userId } = useSelector(
    ({ investor, authReducer }: RootStateType) => ({
      investorData: investor.investorData,
      token: authReducer.token,
      userId: authReducer.userId,
    })
  );
  const { selectedRows, nomineeIndex = null } = location.state;
  const nomineesData = selectedRows[0];

  useEffect(() => {
    if (!Object.keys(nomineesData).length) {
      history.push("/");
      return;
    }
    firstRender()
    
  }, []);

  const [relationshipList, setRelationshipList] = useState([]);
  const [countriesList, setCountriesList] = useState([]);
  const [nominees, setNominees] = useState<NOMINEEINFO[]>([]);
  const { nominees: data = [], investorName = "" } = nomineesData;
  const [noNomineeFlag, setNoNomineeFlag] = useState(false);
  const [soaFlag, setsoaFlag] = useState<string>('Yes');
  const [deleteIndex, setDeleteIndex] = useState<any>("");
  const [show, setShow] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);
  const [showShareModal, setShowShareModal] = useState<{
    show: boolean;
    text: string;
  }>({
    show: false,
    text: "",
  });
  const firstRender = async () => {
    try {
      const [relationShipResponse, countriesListResponse] = await Promise.all([
        getRelationShipList()(dispatch),
        getCountriesList()(dispatch),
      ]);
  
      setRelationshipList(
        relationShipResponse.Dtinformation.map((item: { rm_relation: string }) => ({
          label: item.rm_relation,
          value: item.rm_relation,
        }))
      );
  
      setCountriesList(
        countriesListResponse.Dtinformation.map((item: { country_name: string }) => ({
          label: item.country_name,
          value: item.country_name,
        }))
      );
    } catch (error) {
      console.error("Error in firstRender:", error);
    }
  };
  
  useEffect(() => {
    setNominees(
      !!data.length && selectedRows.length === 1
        ? data.slice(0, 3).map((_ele: any) => {
          let nomineeState = {
            relation: [
              "mother",
              "son",
              "daughter",
              "father",
              "spouse",
            ].includes(_ele?.relation?.toLowerCase())
              ? _ele.relation?.toLowerCase()
              : _ele.relation?.toLowerCase()
                ? "others"
                : "",
            name: _ele.name || "",
            dob: getDate(_ele.dob),
            share: _ele.percent,
            address1: _ele?.address?.line1,
            address2: _ele?.address?.line2,
            address3: _ele?.address?.line3,
            ..._ele?.address,
            guardianName: _ele?.guardian?.name,
            isEditable: false,
            showDetails: false,
            editShare: false,
            isNewlyAdded: false,
            addressCheck: false,
            id: _ele.id,
            isEdited: false,
          };
          return { ...nomineeState, initialState: nomineeState };
        })
        : [
          {
            ...initialValues,
            isEditable: false,
            showDetails: false,
            editShare: false,
            isNewlyAdded: true,
            isEdited: false,
          },
        ]
    );
  }, []);

  // useEffect(() => {
  //   setNoNomineeFlag(!data.length);
  // }, [data.length]);

  const handleAddNomiee = () => {
    setNominees([
      ...nominees,
      { ...initialValues, isEditable: true, isNewlyAdded: true },
    ]);
  };

  const handleAddressCheck = (index: number, value: boolean) => {
    if (!value) {
      setNominees((prev) => {
        return prev.map((currentNominee, i) => {
          if (Number(index) !== i) return currentNominee;
          return {
            ...currentNominee,
            addressCheck: value,
            address1: "",
            address2: "",
            address3: "",
            city: "",
            state: "",
          };
        });
      });
    } else {
      const {
        address: { line1 = "", line2 = "",line3 = "" },
        address,
      } = nomineesData;

      setNominees((prev) => {
        return prev.map((currentNominee, i) => {
          if (Number(index) !== i) return currentNominee;
          return {
            ...currentNominee,
            addressCheck: value,
            address1: line1,
            address2: line2,
            address3: line3,
            ...address,
          };
        });
      });
    }
  };
  const handleInCapacitation = (index: number, value: boolean) => {
    setNominees((prev) => {
      return prev.map((currentNominee, i) => {
        if (Number(index) !== i) {
          return {
            ...currentNominee,
            inCapacitation: value ? false : currentNominee.inCapacitation,
          };
        }
        return {
          ...currentNominee,
          inCapacitation: value,
        };
      });
    });
  };

  const cancelFormSubmission = (index: number, id: string) => {
    setNominees((prevState: NOMINEEINFO[]) => {
      const nominees = [...prevState];
      const nominee = nominees[index];
      nominees[index] = {
        ...nominee,
        ...nominee.initialState,
        isEditable: false,
      };
      return nominees;
    });
  };

  const resetForm = (index: number) => {
    const nominee = [...nominees];
    nominee[index] = { ...initialValues, isEditable: true };
    setNominees(nominee);
  };

  const handleNomineeChange = (key: any, value: any, index: any) => {
    const nominee: any[] = [...nominees];
    nominee[index][key] = value;
    setNominees(nominee);
  };

  const handleDeleteNominee = (ind: number) => {
    const updatedNominees = nominees.map((_ele: NOMINEEINFO) => ({
      ..._ele,
      isEdited: true,
    }));
    setNominees(
      updatedNominees.filter(
        (_ele: NOMINEEINFO, index: number) => index !== ind
      )
    );
  };

  const handleSubmit = () => {
    try {
      setShow(false);
      handleDeleteNominee(deleteIndex);
    } catch (err: any) {
      alert(err.message);
    }
  };

  const nomineeRequestMetadata = {
    fund: "176",
    userId: userId,
    Ihno: "",
    Branch: "DA99",
    Entby: token.split("-")[1]
  }

  const dispatch = useDispatch();

  const handleUpdateNominee = async () => {
    if (noNomineeFlag) {
      try {
        setLoading(true);
        const nomineeApiPayload = {
          isDIT:true,
          email: nomineesData.email,
          mobile: nomineesData.mobile,
          pan: investorData.PAN,
          distributor_id: token,
          data: selectedRows.map((nomineeData) => {
            return {
              folio: nomineeData.folio,
              amc: nomineeData.amc,
              amc_name: nomineeData.amcName,
              noNominee: "Y",
              nominees: [],
              eNomType: "F",
              eSignFlag: "",
              eNomDocId: "",
            };
          }),
        };
        const nomineeValidationPayload = {
          ...nomineeRequestMetadata,
          nominees: [] as any[],
          noNomineeDeclaration: noNomineeFlag
        }
        // const response = await validateNomineeDetails(nomineeValidationPayload)(dispatch)
        // if (!!response.success) {
          const apiRes = await saveNominee(nomineeApiPayload)(dispatch);
          if (apiRes?.status === 201) {
            history.replace("/new-transaction/nct-type/success", {
              state: {
                succesMessage: apiRes.message,
              },
            });
          }
        // }
      } catch (err: any) {
        alert(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const totalShare = nominees
          .map((_ele: NOMINEEINFO) => _ele.share)
          .reduce((sum: number = 0, current) => sum + Number(current), 0);
        if (totalShare > 100) {
          throw Error(dashboard.UpdateNominee.NoteModals.greaterModal);
        }
        if (totalShare < 100) {
          throw Error(dashboard.UpdateNominee.NoteModals.lessModal);
        }
        if (nominees.length) {
          let names: string[] = [];
          let error = false;
          nominees.some((nominee) => {
            if (names.includes(nominee.name)) {
              error = true;
            }
            names = [...names, nominee.name];
            return false;
          });
          if (error)
            throw Error("Nominees name should be different from each other");
        }
        const findMissingFields = (nominee: any) =>
          Object.entries(requiredFieldsMap)
            .filter(([field, _label]) => {
              const value = nominee[field];
              return (
                value === undefined ||
                value === null ||
                value.toString().trim() === ""
              );
            })
            .map(([_field, label]) => label);

        const nomineeErrors: string[] = [];

        nominees.forEach((nominee, index) => {
          const missing = findMissingFields(nominee);
          if (missing.length > 0) {
            nomineeErrors.push(
              `Nominee ${index + 1} is missing: ${missing.join(", ")} — all are required to proceed.`
            );
          }
        });

        if (nomineeErrors.length > 0) {
          alert(nomineeErrors.join("\n"));
          return;
        }
        const incapacitatedNominee = nominees.find(n => n.inCapacitation);
        const index = incapacitatedNominee ? nominees.indexOf(incapacitatedNominee) + 1 : null;
        const incapacitationPayload = incapacitatedNominee ? {
          IncapacitationValue: `NOM${index}`,
          IncapacitationThresholdPercent: incapacitatedNominee?.inCapacitationAmountorPercentageCheck === "Percentage" ? incapacitatedNominee?.inCapacitationAmount
            : "",
          IncapacitationThresholdAum: incapacitatedNominee?.inCapacitationAmountorPercentageCheck !== "Percentage" ? incapacitatedNominee?.inCapacitationAmount
            : "",
        } : ""

        const payload: FormattedNomineeType[] = nominees.map(
          (_ele: NOMINEEINFO, ind: number) => {
            const isPinCodeValid = isOnlyNumber(_ele.pincode);
            const updatedPinCode = isPinCodeValid ? Number(_ele.pincode) : "";
            const updatedAddress3 = !isPinCodeValid
              ? `${_ele.address3 || ""} ${_ele.pincode}`.trim()
              : _ele.address3;
        
            return {
              nominee: ind + 1,
              name: _ele.name,
              percent: _ele.share,
              IdentityType: _ele.idType,
              IDNumber: _ele.idNumber,
              email: _ele.email,
              mobile: _ele.mobileNumber,
              NomType: `NOM${ind + 1}`,
              dob: getDateString(_ele.dob),
              inCapacitation: _ele.inCapacitation,
              inCapacitationAmountorPercentageCheck: _ele.inCapacitationAmountorPercentageCheck,
              inCapacitationAmount: _ele.inCapacitationAmount,
              NomIncapacitationFlag: _ele.inCapacitation,
              address: {
                line1: _ele.address1 || "",
                line2: _ele.address2 || "",
                line3: updatedAddress3 || "",
              },
              addressCheck: _ele.addressCheck || false,
              city: _ele.city,
              state: _ele.state,
              pinCode: updatedPinCode,
              country: _ele.country,
              relation: _ele.relation,
              guardian: {
                name: _ele.guardianName || "",
              },
            };
          }
        );
        
        const flattenedNominees = payload.map(nominee => {
          const { address, guardian, NomType, ...rest } = nominee;
          return {
            ...rest,
            nomType: NomType || "", 
            address: address?.line1 || "",
            Add2: address?.line2 || "",
            Add3: address?.line3 || "",
            guardianName: guardian?.name || ""
          };
        });
        
        const nomineeValidationPayload = {
          nominees: flattenedNominees,
          ...nomineeRequestMetadata,
          ...incapacitationPayload,
          SOAFlag: soaFlag === "Yes" ? "Y" : "N",
          noNomineeDeclaration: noNomineeFlag
        };
        // const response = await validateNomineeDetails(nomineeValidationPayload)(dispatch)
        // if(!!response.success){
        const nomineeApiPayload = {
          isDIT:true,
          email: nomineesData.email,
          mobile: nomineesData.mobile,
          pan: investorData.PAN,
          distributor_id: token,
          SOAFlag: soaFlag === "Yes" ? "Y" : "N",
          ...incapacitationPayload,
          data: selectedRows.map((nomineeData) => {
            return {
              folio: nomineeData.folio,
              amc: nomineeData.amc,
              amc_name: nomineeData.amcName,
              noNominee: noNomineeFlag ? "Y" : "N",
              nominees: noNomineeFlag ? [] : payload,
              eNomType: "F",
              eSignFlag: "",
              eNomDocId: "",
            };
          }),
        };
        try {
          setLoading(true);
          const apiRes = await saveNominee(nomineeApiPayload)(dispatch);
          if (apiRes?.status === 201) {
            history.replace("/new-transaction/nct-type/success", {
              state: {
                succesMessage: apiRes.message,
              },
            });
          }
        } catch (err: any) {
          alert(err.message);
        } finally {
          setLoading(false);
        }
      // }
        // const { pan = '', pekrn = '', mobile = '' } = props;
        // let res = await props.sendPhoneOTP({
        //     mobile,
        //     pan,
        //     pekrn,
        //     action: OTP_ACTIONS.updateNominee,
        // });
        // props.history.replace('update-nominee-edit-otp', {
        //     mobile: props.mobile,
        //     pan: props.pan,
        //     data: [{ folio: nomineesData.id, amc: nomineesData.amc, nominees: payload }],
        //     ...(res || {}).body,
        // });
      } catch (e: any) {
        setShowShareModal({ show: true, text: e.message });
        // alert(e.message);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="curved-bg">
      {/* { */}
      {/*     <ActionHeader */}
      {/*         header={dashboard.UpdateNominee.UpdateNomineeHeading} */}
      {/*         handleClick={() => { */}
      {/*             nominees.every((_ele) => !_ele.isEditable) */}
      {/*                 ? props.history.goBack() */}
      {/*                 : nominees.map( */}
      {/*                     (_ele, index) => */}
      {/*                         _ele.isEditable && cancelFormSubmission(index, `${index}`), */}
      {/*                 ); */}
      {/*         }} */}
      {/*     /> */}
      {/* } */}
      <div className="curved-bg-content curved-bg-table-outer update-nominee-screen">
        <div className="curved-bg-content-table">
          {/* <h5> {dashboard.UpdateNominee.UpdateNomineeInfo}</h5> */}
          <div className="curved-table-content update-nominee">
            {nominees.every((_ele: NOMINEEINFO) => !_ele.isEditable) && (
              <div style={{ marginTop: "15px" }}>
                <CheckBoxField
                  onChange={(e) => setNoNomineeFlag(!noNomineeFlag)}
                  value={noNomineeFlag}
                  label={dbCommercial.profileDetails.nominees.noNominee}
                />
              </div>
            )}
            {!noNomineeFlag && (
              <Box
                sx={{
                  padding: "16px 10px 5px 10px",
                  mb: 1,
                  border: '1px dashed silver',
                  borderRadius: '8px',
                  mt: 1,
                  maxWidth: "auto",
                  width: '100%',
                }}
              >
                <Typography variant="body1" style={{ marginBottom: 8 }}
                >
                  I / We want the details of my / our nominee to be printed in the statement of holding or statement of account, provided to me/us by the AMC/DP as follows; (please tick, as appropriate):
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="subtitle1" style={{ fontWeight: 500, marginRight: 10 }}>
                    Display of nominees:
                  </Typography>
                  <RadioGroup
                    row
                    value={soaFlag}
                    onChange={(e) => setsoaFlag(e.target.value)}
                    style={{ padding: "10px 0px 0px 10px" }}
                  >
                    {[
                      { label: 'Yes', value: 'Yes' },
                      { label: 'No', value: 'No' },
                    ].map((option) => (
                      <FormControlLabel
                        key={option.value}
                        value={option.value}
                        control={<Radio style={{ color: '#007ac8' }} />}
                        label={option.label}
                        style={{ marginRight: 10 }}
                      />
                    ))}
                  </RadioGroup>
                </Box>
              </Box>
            )}
            {!noNomineeFlag &&
              nominees.map((_ele: NOMINEEINFO, index: number) =>
                !_ele.isEditable ? (
                  <div className="nominee-list">
                    <div className="nominee-list-single">
                      <div className="nominee_name">
                        <span>
                          <Image src="/images/family-icon.svg" alt="icon" />
                        </span>
                        {getNameIndex(index + 1)}{" "}
                        {dashboard.UpdateNominee.nomineeText}
                        <div className="nominee_detail_edit mobile_mode">
                          <Image
                            src="/images/edit.svg"
                            alt="icon"
                            onClick={() => {
                              setNominees((prevState: NOMINEEINFO[]) => {
                                const nominees = [...prevState];
                                const { initialState, ...nominee } =
                                  nominees[index];
                                nominees[index].initialState = nominee;
                                nominees[index].isEditable = true;
                                return nominees;
                              });
                            }}
                          />
                          {nominees.length > 1 && (
                            <Image
                              src="/images/delete_nominee.svg"
                              alt="icon"
                              onClick={() => {
                                setShow(true);
                                setDeleteIndex(index);
                              }}
                            />
                          )}
                        </div>
                      </div>
                      <div className="nominee-detail-right">
                        <div className="nominee-detail-top">
                          <div className="nominee_detail">
                            <p className="label">
                              {" "}
                              {dashboard.UpdateNominee.name}
                            </p>
                            <p className="value">{_ele.name} </p>
                          </div>
                          <div className="nominee_detail nominee_detail_relation">
                            <p className="label">
                              {dashboard.UpdateNominee.relation}
                            </p>
                            <p className="value">
                              {_ele.relation.slice(0, 1).toUpperCase() +
                                _ele.relation.slice(1)}
                            </p>
                          </div>
                          <div className="nominee_detail nominee_detail_share">
                            {!_ele.editShare ? (
                              <>
                                <p className="label">
                                  {dashboard.UpdateNominee.share}
                                </p>
                                <p className="value">
                                  {_ele.share}%
                                  <Image
                                    src="/images/edit.svg"
                                    alt="icon"
                                    onClick={() =>
                                      handleNomineeChange(
                                        "editShare",
                                        true,
                                        index
                                      )
                                    }
                                  />
                                </p>
                              </>
                            ) : (
                              <div className="nominee_detail_share_edit">
                                <TextInput
                                  label="%(share)"
                                  variant="outlined"
                                  value={_ele.share}
                                  onBlur={(e) => {
                                    if (Number(e.target.value) === 0) {
                                      alert("Nominee share should not be 0");
                                      return;
                                    }
                                    handleNomineeChange(
                                      "editShare",
                                      false,
                                      index
                                    );
                                    handleNomineeChange(
                                      "isEdited",
                                      true,
                                      index
                                    );
                                  }}
                                  onChange={(e) => {
                                    if (Number(e.target.value) <= 100) {
                                      handleNomineeChange(
                                        'share',
                                        e.target.value,
                                        index,
                                      )
                                    }
                                  }}
                                />
                                <Image
                                  src="/images/tick-green.svg"
                                  alt="icon"
                                  onClick={() => {
                                    handleNomineeChange(
                                      "editShare",
                                      false,
                                      index
                                    );
                                    handleNomineeChange(
                                      "isEdited",
                                      true,
                                      index
                                    );
                                  }}
                                />
                              </div>
                            )}
                          </div>
                          {/* <div className="nominee_detail_more">
                            {!_ele.showDetails ? (
                              <a
                                // href="#"
                                onClick={() =>
                                  handleNomineeChange(
                                    "showDetails",
                                    true,
                                    index
                                  )
                                }
                              >
                                {dashboard.UpdateNominee.more}
                                <Image
                                  src="/images/down-arrow-purple.svg"
                                  alt="icon"
                                />
                              </a>
                            ) : (
                              <a
                                // href="#"
                                onClick={() =>
                                  handleNomineeChange(
                                    "showDetails",
                                    false,
                                    index
                                  )
                                }
                              >
                                {dashboard.UpdateNominee.less}
                                <Image
                                  src="/images/up-arrow-purple.svg"
                                  alt="icon"
                                />
                              </a>
                            )}
                          </div> */}
                          <div className="nominee_detail_edit desktop_mode">
                            <Image
                              src="/images/edit.svg"
                              alt="icon"
                              onClick={() => {
                                setNominees((prevState: NOMINEEINFO[]) => {
                                  const nominees = [...prevState];
                                  const { initialState, ...nominee } =
                                    nominees[index];
                                  nominees[index].initialState = nominee;
                                  nominees[index].isEditable = true;
                                  return nominees;
                                });
                              }}
                            />
                            {nominees.length > 1 && (
                              <Image
                                src="/images/delete_nominee.svg"
                                alt="icon"
                                onClick={() => {
                                  setShow(true);
                                  setDeleteIndex(index);
                                }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <AddNominee
                    initialValues={_ele}
                    index={index + 1}
                    handleAddNominee={handleAddNomiee}
                    countriesList={countriesList}
                    investorData={investorData}
                    handleResetForm={(ind: number) => resetForm(ind)}
                    handleNomineeChange={(
                      key: string,
                      value: any,
                      ind: number
                    ) => handleNomineeChange(key, value, ind)}
                    handleAddressCheck={handleAddressCheck}
                    handleInCapacitation={handleInCapacitation}
                    saveNominee={(key: string, value: any, ind: number) => {
                      const nominee = [...nominees];
                      nominee[ind] = {
                        ...nominee[ind],
                        isEditable: false,
                        isNewlyAdded: false,
                        isEdited: true,
                      };
                      setNominees(nominee);
                    }}
                    nominees={nominees}
                    investorName={investorName}
                    relations={
                      _ele.relation
                        ? relationshipList.filter((relation: RELATIONS) => {
                          const addedRelations = nominees
                            .map((nominee: NOMINEEINFO) => {
                              if (nominee.relation !== _ele.relation)
                                return nominee.relation;
                            })
                            .filter((ele) => ele);
                          return !addedRelations.includes(relation.label);
                        })
                        : relationshipList.filter((relation: RELATIONS) => {
                          const addedRelations = nominees.map(
                            (_ele: NOMINEEINFO) => _ele.relation
                          );
                          return !addedRelations.includes(relation.label);
                        })
                    }
                    pan={pan}
                    cancelFormSubmission={cancelFormSubmission}
                  />
                )
              )}
            {!noNomineeFlag && nominees.length < 3 && (
              <div className="add-nominee-btn">
                <a onClick={() => handleAddNomiee()}>
                  + {dashboard.UpdateNominee.addNominee}
                </a>
              </div>
            )}
            {nominees.every(
              (_ele: NOMINEEINFO) => !_ele.isEditable && !_ele.editShare
            ) && (
                <div className="curved-bg-content-inner-bottom">
                  <SubmitButtonWithLoader
                    type="submit"
                    loading={loading}
                    labelWhileLoading={"Submitting"}
                    className="customBtn"
                    label={"Submit"}
                    onClick={handleUpdateNominee}
                  />
                </div>
              )}

            <NoteModals
              showModal={show}
              info={dashboard.UpdateNominee.NoteModals.deleteNominee}
              proceedBtn={dashboard.noteModals.otpModal.proceedText}
              cancelBtn={dashboard.noteModals.otpModal.cancelText}
              onProceed={handleSubmit}
              onCancel={() => setShow(false)}
            />
            <NoteModals
              showModal={showShareModal.show}
              info={showShareModal.text}
              proceedBtn={dashboard.UpdateNominee.NoteModals.okay}
              extraClass="share-modal"
              onProceed={() =>
                setShowShareModal({
                  show: false,
                  text: "",
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
}
const requiredFieldsMap = {
  relation: "Relation",
  name: "Full Name",
  mobileNumber: "Mobile Number",
  email: "Email Address",
  idType: "ID Type",
  idNumber: "ID Number",
  address1: "Address Line 1",
  city: "City",
  state: "State",
  pincode: "Pincode",
  country: "Country",
};